export default function useParams() {
  return new URLSearchParams(document.location.search)
}
